import moment from 'moment';

const toDateOnly = value => moment(value).format('YYYY-MM-DD');

const getTrainingSessionMaxEndDate = ({ startDate, availableTo, validityMonthCount }) => {
  const candidates = [];

  if (availableTo) {
    candidates.push(toDateOnly(availableTo));
  }

  const validityMonths = Number(validityMonthCount ?? 0);
  if (startDate && validityMonths > 0) {
    candidates.push(moment(startDate).add(validityMonths, 'months').format('YYYY-MM-DD'));
  }

  if (!candidates.length) {
    return null;
  }

  const maxDateString = candidates.reduce((min, current) => (current < min ? current : min));
  return moment(maxDateString, 'YYYY-MM-DD').toDate();
};

export default getTrainingSessionMaxEndDate;
